export enum DesignConsoleRouteName {
  Templates = 'templates',
  Layout = 'layout',
  Color = 'color',
  Details = 'details',
  Art = 'art',
  Font = 'font',
  Css = 'css',
  EventPhoto = 'eventPhoto',
}

// Intended to be Pick<UseDesignConsoleRouterReturn, 'goTo' | 'goToDetailsTab'>
// However, Referencing UseDesignConsoleRouterReturn leads to a circular import.
export type DesignConsoleRouteComponentProps = Readonly<{
  goTo: (tabValue: string) => void;
  goToDetailsTab: () => void;
}>;

export type DesignConsoleRoute = Readonly<{
  name: `${DesignConsoleRouteName}`;
  component: (args: DesignConsoleRouteComponentProps) => React.ReactElement;
  label: string;
  icon: React.ReactElement;
  // Optional minimum width for the left side panel of the EditorV3 when this route is rendered
  minWidth?: number | string;
  // Optional maximum width for the left side panel of the EditorV3 when this route is rendered
  maxWidth?: number | string;
}>;

export type DesignConsoleTelemetryRouteName = (typeof DesignConsoleRouteName)[keyof typeof DesignConsoleRouteName];

export type DesignConsoleTelemetryRoutes = DesignConsoleTelemetryRouteName | 'fullScreenPreview' | 'websiteDesignerPrintCrossSellDialog' | 'headerLayoutUpgradeDialog';
